import * as APITypes from "../../generated-types/v2/Api";
import { makePath } from "../../../url";
import { getJSON } from "../../request";
import { APIContext } from "../../types";
import { APITypesV2 } from "../../../..";
import { applyParams } from "../../../params";

export type ConsentAPI = ReturnType<typeof createConsentAPIv2>;

export function createConsentAPIv2({ buildURL, fetchPagedJSON }: APIContext) {
  function getListOfConsents({ patientId }: { patientId: string }) {
    const path = makePath(["api", "v2", "patient", patientId, "consent"]);
    const url = buildURL(path);
    const request = getJSON(url);

    return fetchPagedJSON<APITypes.ConsentWithSignature>(request);
  }

  function getConsentHistory({
    patientId,
    consentId,
    token,
  }: APITypesV2.PatientConsentV2RenderPatientConsentHistoryParams) {
    const path = makePath([
      "api",
      "v2",
      "patient",
      patientId,
      "consent",
      consentId,
      "history",
    ]);

    const url = buildURL(path);
    applyParams(url.searchParams, {
      token,
    });

    return url;
  }

  return {
    getListOfConsents,
    getConsentHistory,
  };
}
